export default __webpack_public_path__ + "static/media/about-us.4e47904b.png";